import Vue from 'vue';

Vue.mixin({
  methods: {
    ImagePath(path) {
      return `${process.env.PUBLIC_URL}/${path}`;
    }
  }
});
